module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ds-schedule",
    class: _vm.classes
  }, [(_vm.showRange) ? _c('div', {
    staticClass: "ds-schedule-span"
  }, [_vm._t("scheduleSpan", [_c('ds-schedule-span', {
    attrs: {
      "schedule": _vm.schedule,
      "day": _vm.day,
      "read-only": _vm.readOnly
    }
  })], null, {
    schedule: _vm.schedule,
    day: _vm.day
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ds-schedule-type-line"
  }, [_c('div', {
    staticClass: "ds-schedule-type"
  }, [_vm._t("scheduleType", [_c('ds-schedule-type', {
    attrs: {
      "day": _vm.day,
      "schedule": _vm.schedule,
      "read-only": _vm.readOnly
    },
    on: {
      "change": _vm.setType,
      "custom": _vm.custom
    }
  })], null, {
    schedule: _vm.schedule,
    day: _vm.day,
    setType: _vm.setType,
    custom: _vm.custom
  })], 2)]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_vm._t("scheduleTimes", [_c('ds-schedule-times', {
    attrs: {
      "schedule": _vm.schedule,
      "read-only": _vm.readOnly
    }
  })], null, {
    schedule: _vm.schedule,
    day: _vm.day
  })], 2), _vm._v(" "), (!_vm.isReadOnly) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_vm._t("scheduleFooter", null, null, {
    schedule: _vm.schedule,
    day: _vm.day
  }), _vm._v(" "), _c('ds-schedule-type-custom-dialog', _vm._b({
    ref: "customScheduler"
  }, 'ds-schedule-type-custom-dialog', {
    $scopedSlots: _vm.$scopedSlots
  }, false))], 2) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a5201042","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Schedule.vue
// module id = 425
// module chunks = 1